import Header from '../components/Header'
import Footer from '../components/Footer'

type LegalSection = {
  title: string
  paragraphs: string[]
  list?: string[]
}

const sections: LegalSection[] = [
  {
    title: '1. 基本理念',
    paragraphs: [
      '一般社団法人 日本ITビジネス・プロフェッショナル協会（以下「当協会」といいます）は、公益性の高い団体として、会員および社会から信頼される情報管理体制の構築を最重要課題の一つと位置づけています。',
      '個人情報を適切に取り扱うことは、ITビジネスの健全な発展とプロフェッショナル人材の活躍を支える基盤です。当協会は、関連する法令・ガイドラインを遵守し、透明性と説明責任をもって個人情報の保護に努めます。',
    ],
  },
  {
    title: '2. 取得する個人情報',
    paragraphs: ['当協会は、事業目的の達成に必要な範囲で、以下の個人情報を取得します。'],
    list: [
      '氏名、ふりがな、所属組織、役職、連絡先（メールアドレス・電話番号等）',
      'お問い合わせ内容、各種申請書に記載された情報、本人確認に必要な書類情報',
      'イベント・セミナー等への参加履歴、アンケート回答、会員活動記録',
      'ウェブサイト利用に伴い取得するCookieやアクセスログ等の技術情報（個人が特定できない形式で利用目的に限定）',
    ],
  },
  {
    title: '3. 個人情報の利用目的',
    paragraphs: ['取得した個人情報は、以下の目的で使用します。目的外利用は行いません。'],
    list: [
      '協会事業（会員制度、研修、認定、広報、人材マッチング等）の運営および案内',
      'お問い合わせ・相談・申請への対応と履歴管理',
      'イベント・プログラムの企画改善、統計分析、サービス向上のための調査',
      '法令に基づく義務の履行および行政機関等からの要請への対応',
    ],
  },
  {
    title: '4. 法令遵守と組織的管理',
    paragraphs: [
      '当協会は個人情報保護法その他関連法令・ガイドラインを遵守し、理事会の監督のもとで管理責任者を配置して継続的に運用状況を監査します。',
      '役職員および委託先に対し、定期的な研修と機密保持契約を通じて個人情報保護意識の徹底を図ります。',
    ],
  },
  {
    title: '5. 安全管理措置',
    paragraphs: ['個人情報の漏えい、滅失または毀損を防止するため、以下の安全管理措置を講じます。'],
    list: [
      'アクセス権限の最小化と多要素認証を含む技術的制御',
      '暗号化・ログ監査・脅威検知ソリューションによるシステム保護',
      '紙媒体・端末の保管および持ち出し管理、廃棄手順の厳格化',
      '定期的なリスクアセスメントとインシデント対応訓練の実施',
    ],
  },
  {
    title: '6. 第三者提供・委託について',
    paragraphs: [
      '当協会は、法令に基づく場合や本人の同意を得た場合を除き、個人情報を第三者に提供しません。',
      '業務委託が必要な場合は、委託先を適正に選定し、機密保持契約および監督を通じて安全管理措置の履行を徹底します。',
    ],
  },
  {
    title: '7. Cookie等の利用',
    paragraphs: [
      'ウェブサイトでは、閲覧状況を把握しコンテンツ改善やセキュリティ強化に活用するため、Cookieや類似技術を使用する場合があります。取得する情報には個人を識別できるデータを含めず、ブラウザ設定で受け入れ可否を選択できます。',
      '第三者提供型の解析サービスを導入する際は、利用目的とオプトアウト方法を別途告知します。',
    ],
  },
  {
    title: '8. 開示・訂正・利用停止等の請求',
    paragraphs: [
      '本人または代理人から、当協会が保有する個人情報の開示・訂正・追加・削除・利用停止等の請求を受けた場合、法令に基づき速やかに対応します。',
      '請求手続きでは、本人確認書類の提示や所定の申請書の提出をお願いすることがあります。',
    ],
  },
  {
    title: '9. お問い合わせ窓口',
    paragraphs: [
      '個人情報の取扱いに関するご相談・苦情・手続きは、下記窓口で受け付けます。お問い合わせ内容に応じて、適切に対応し記録を保管します。',
    ],
    list: ['一般社団法人 日本ITビジネス・プロフェッショナル協会 事務局', '公式ウェブサイト内「お問い合わせ」フォーム'],
  },
  {
    title: '10. 改定',
    paragraphs: [
      '本ポリシーの内容を改定する場合は、当協会ウェブサイトで速やかに公表し、改定日を明記します。重要な変更がある場合は、メール配信など合理的な方法でご案内します。',
    ],
  },
]

const PrivacyPolicyPage = () => {
  const breadcrumbs = [
    { label: 'ホーム', to: '/' },
    { label: 'プライバシーポリシー' },
  ]

  return (
    <>
      <Header breadcrumbs={breadcrumbs} />
      <main>
        <section className="page-hero" aria-labelledby="privacy-policy-title">
          <div className="container">
            <p className="section-pretitle">PRIVACY POLICY</p>
            <h1 id="privacy-policy-title" className="page-hero-title">
              プライバシーポリシー
            </h1>
            <p className="page-hero-lead">
              当協会は、ITビジネス領域における信頼性と公益性を高める使命のもと、個人情報を厳正かつ透明性の高い手続きで取り扱います。
              以下の方針に基づき、会員・利用者・関係者の権利と利益を保護します。
            </p>
          </div>
        </section>

        <section className="legal-page" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="legal-sections">
              {sections.map((section) => (
                <article key={section.title} className="legal-section">
                  <h2>{section.title}</h2>
                  {section.paragraphs.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                  {section.list && (
                    <ul>
                      {section.list.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  )}
                </article>
              ))}
            </div>
            <div className="legal-updated" aria-label="策定日">
              <span>制定日: 2026年4月1日</span>
              <span>最終改定日: 2026年4月1日</span>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  )
}

export default PrivacyPolicyPage


